module.exports = __webpack_public_path__ + "static/media/alarm-plus.661c3305.svg";